import { Injectable, InjectionToken } from "@angular/core";
import { EFavoriteGetQueryType, EFavoriteType, FavoriteDeleteCommandResult, FavoriteGetQueryResult, FavoriteSetCommandResult, ProductIdentifierDto } from "../../INTEGRA_Shop_Client";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export abstract class IFavoriteApiService {
  abstract swagFavoriteDelete(productIdentifierList: ProductIdentifierDto[], favoriteType?: EFavoriteType | undefined): Observable<FavoriteDeleteCommandResult>;

  abstract swagFavoriteSet(productIdentifierList: ProductIdentifierDto[], favoriteType?: EFavoriteType | undefined): Observable<FavoriteSetCommandResult>;

  abstract swagFavoriteGet(favoriteGetQueryType: EFavoriteGetQueryType): Observable<FavoriteGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IFavoriteApiServiceToken = new InjectionToken<IFavoriteApiService>('IFavoriteApiServiceToken');
